import { createSlice } from '@reduxjs/toolkit';

import { status } from 'utils/const';
import { selectors } from './selectors';
import { thunks } from './thunks';

const defaultValues = {
  email: '',
  phone: '',
  customerSearch: '',
};

const initialState = {
  defaultInvoiceInfo: defaultValues,
  customerSearch: null,
  itemSearch: null,
  invoiceId: null,
  invoiceItems: [],

  createInvoiceStatus: status.IDLE,
  fetchingSearchStatus: status.IDLE,
  createItemStatus: status.IDLE,
  editItemStatus: status.IDLE,
};

const slice = createSlice({
  name: 'createInvoice',
  initialState,
  reducers: {
    resetState(state) {
      Object.assign(state, initialState);
    },
    clearCustomerSearch: (state) => {
      state.customerSearch = null;
    },
    clearItemSearch: (state) => {
      state.itemSearch = null;
    },
    clearInvoiceItems: (state) => {
      state.invoiceItems = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(thunks.createInvoice.pending, (state) => {
        state.createInvoiceStatus = status.PENDING;
      })
      .addCase(thunks.createInvoice.fulfilled, (state, { payload }) => {
        state.createInvoiceStatus = status.SUCCESS;
        state.invoiceId = payload.data.invoice.id;
      })
      .addCase(thunks.createInvoice.rejected, (state) => {
        state.createInvoiceStatus = status.FAIL;
      })

      .addCase(thunks.customerSearch.pending, (state) => {
        state.fetchingSearchStatus = status.PENDING;
      })
      .addCase(thunks.customerSearch.fulfilled, (state, { payload }) => {
        state.customerSearch = payload.data;
        state.fetchingSearchStatus = status.SUCCESS;
      })
      .addCase(thunks.customerSearch.rejected, (state) => {
        state.fetchingSearchStatus = status.FAIL;
      })

      .addCase(thunks.itemSearch.pending, (state) => {
        state.fetchingSearchStatus = status.PENDING;
      })
      .addCase(thunks.itemSearch.fulfilled, (state, { payload }) => {
        state.itemSearch = payload.data;
        state.fetchingSearchStatus = status.SUCCESS;
      })
      .addCase(thunks.itemSearch.rejected, (state) => {
        state.fetchingSearchStatus = status.FAIL;
      })

      .addCase(thunks.getInvoiceItems.pending, (state) => {
        state.fetchingSearchStatus = status.PENDING;
      })
      .addCase(thunks.getInvoiceItems.fulfilled, (state, { payload }) => {
        state.invoiceItems = payload.data;
        state.fetchingSearchStatus = status.SUCCESS;
      })
      .addCase(thunks.getInvoiceItems.rejected, (state) => {
        state.fetchingSearchStatus = status.FAIL;
      })

      .addCase(thunks.createInvoiceItem.pending, (state) => {
        state.createItemStatus = status.PENDING;
      })
      .addCase(thunks.createInvoiceItem.fulfilled, (state) => {
        state.createItemStatus = status.SUCCESS;
      })
      .addCase(thunks.createInvoiceItem.rejected, (state) => {
        state.createItemStatus = status.FAIL;
      })

      .addCase(thunks.editInvoiceItem.pending, (state) => {
        state.editItemStatus = status.PENDING;
      })
      .addCase(thunks.editInvoiceItem.fulfilled, (state) => {
        state.editItemStatus = status.SUCCESS;
      })
      .addCase(thunks.editInvoiceItem.rejected, (state) => {
        state.editItemStatus = status.FAIL;
      });
  },
});

const createInvoice = {
  actions: slice.actions,
  thunks,
  selectors,
};

export { createInvoice };
export default slice.reducer;
